import React, { useEffect, useState, useRef } from 'react';
import axios from '../axiosInstance'; // custom instance
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Edit2, X, Upload, Download, Copy } from 'lucide-react';

export default function Warehouses() {
  const [warehouses, setWarehouses] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [stateFilter, setStateFilter] = useState('');
  const [cityFilter, setCityFilter] = useState('');
  const [branchFilter, setBranchFilter] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tableError, setTableError] = useState('');
  const [formError, setFormError] = useState('');
  const [uploadError, setUploadError] = useState('');
  const [branches, setBranches] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [role, setRole] = useState('');

  const [form, setForm] = useState({
    id: null,
    warehouse_name: '',
    contact_name: '',
    contact_email: '',
    contact_mobile_no: '',
    address: '',
    type: '',
    latitude: '',
    longitude: '',
    stateId: '',
    districtId: '',
    taluka: '',
    branchId: '',
  });
  const [copiedId, setCopiedId] = useState(null);
  const [copiedCodeId, setCopiedCodeId] = useState(null);

  const token = localStorage.getItem('token');

  const handleCopy = (address, id) => {
    if (!address) return;
    navigator.clipboard.writeText(address);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1500);
  };

  const handleCopyCode = (code, id) => {
    if (!code) return;
    navigator.clipboard.writeText(code);
    setCopiedCodeId(id);
    setTimeout(() => setCopiedCodeId(null), 1500);
  };

  // Fetch warehouses with optional filters
  const fetchWarehouses = async (
    pageNum = 1,
    limitNum = 10,
    warehouseName = '',
    stateId = '',
    cityId = '',
    branchId = ''
  ) => {
    try {
      let url = `warehouse?page=${pageNum}&limit=${limitNum}`;
      if (warehouseName) url += `&name=${warehouseName}`;
      if (stateId) url += `&state_id=${stateId}`;
      if (cityId) url += `&district_id=${cityId}`;
      if (branchId) url += `&branch_id=${branchId}`;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // setWarehouses(res.data.data || []);
      const list = res.data.data || [];

      const updatedList = list.map((item) => {
        return {
          ...item,
          type: item.service_provider || item.type || ''
        };
      });

      setWarehouses(updatedList);

      setPage(res.data.page || pageNum);
      setLimit(res.data.limit || limitNum);
      setTotal(res.data.total || 0);
      setTableError('');
    } catch (err) {
      console.error(
        'Error fetching warehouses:',
        err.response?.data || err.message
      );
      setTableError('⚠️ Failed to fetch warehouses. Please try again.');
    }
  };
  const fetchBranches = async () => {
    try {
      const res = await axios.get(`user/branches?paginate=false`);
      // console.log(res.data);
      setBranches(res.data || []);
    } catch (err) {
      console.error(
        'Error fetching branches:',
        err.response?.data || err.message
      );
    }
  };
  // Fetch states
  const fetchStates = async () => {
    try {
      const res = await axios.get('states');
      setStates(res.data || []);
    } catch (err) {
      console.error(
        'Error fetching states:',
        err.response?.data || err.message
      );
    }
  };

  // Fetch cities for a state
  const fetchCities = async (stateId) => {
    if (!stateId) return;
    try {
      const res = await axios.get(`cities/state/${stateId}`);

      setCities(res.data || []);
    } catch (err) {
      console.error(
        'Error fetching cities:',
        err.response?.data || err.message
      );
    }
  };

  // Handle form input change
  const handleChange = (e) => {
    if (e.target.name === 'stateId') {
      fetchCities(e.target.value);
      setForm((prev) => ({ ...prev, stateId: e.target.value, districtId: '', branchId: '' }));
    } else {
      setForm({ ...form, [e.target.name]: e.target.value });
    }
  };

  // Form validation
  const validateForm = () => {
    if (!form.warehouse_name) return 'Warehouse Name is required';

    if (!form.branchId) return ' Branch is required';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form.contact_email && !emailRegex.test(form.contact_email))
      return 'Invalid Email format';

    const mobileRegex = /^[0-9]{10}$/;
    if (form.contact_mobile_no && !mobileRegex.test(form.contact_mobile_no))
      return 'Mobile number must be 10 digits';

    if (form.latitude && isNaN(Number(form.latitude)))
      return 'Latitude must be a number';
    if (form.longitude && isNaN(Number(form.longitude)))
      return 'Longitude must be a number';

    return null;
  };

  // Save or update warehouse
  const handleSave = async () => {
    const validationError = validateForm();
    if (validationError) {
      setFormError(validationError);
      return;
    }

    setLoading(true);
    setFormError('');

    const payload = {
      warehouse_name: form.warehouse_name,
      contact_name: form.contact_name,
      contact_email: form.contact_email,
      contact_mobile_no: form.contact_mobile_no,
      address: form.address,
      type: form.type,
      latitude: Number(form.latitude),
      longitude: Number(form.longitude),
      stateId: form.stateId,
      districtId: form.districtId,
      taluka: form.taluka,
      branchId: form.branchId,
    };

    try {
      if (form.id) {
        await axios.patch(`warehouse/${form.id}`, payload);
        alert('✅ Warehouse updated successfully!');
      } else {
        await axios.post('warehouse', payload);
        alert('✅ Warehouse added successfully!');
      }

      setForm({
        id: null,
        warehouse_name: '',
        contact_name: '',
        contact_email: '',
        contact_mobile_no: '',
        address: '',
        type: 'OPEN',
        latitude: '',
        longitude: '',
        stateId: '',
        districtId: '',
        taluka: '',
        branchId: '',
      });
      setIsModalOpen(false);
      fetchWarehouses(page, limit, search, stateFilter, cityFilter, branchFilter);
    } catch (err) {
      console.error('Save error:', err.response?.data || err.message);
      const respData = err.response?.data;
      if (respData && respData.errors && Array.isArray(respData.errors)) {
        const details = respData.errors.map(e => typeof e === 'object' ? (e.error || e.message || JSON.stringify(e)) : e).join(', ');
        setFormError(`${respData.message || 'Validation failed'}: ${details}`);
      } else {
        setFormError(respData?.message || 'Failed to save warehouse');
      }
    } finally {
      setLoading(false);
    }
  };
  const fetchWarehouseById = async (id) => {
    const res = await axios.get(`warehouse/${id}`);
    return res.data;
  };

  // Edit warehouse
  const handleEdit = async (wh) => {
    try {
      // Fetch fresh data from API
      const responseData = await fetchWarehouseById(wh.id);
      const details = responseData.data || responseData;

      // console.log('Fetched warehouse details:', details); // Debug log

      setForm({
        id: details.id,
        warehouse_name: details.warehouse_name || '',
        contact_name: details.contact_name || '',
        contact_email: details.contact_email || '',
        contact_mobile_no: details.contact_mobile_no || '',
        address: details.address || '',
        type: (details.service_provider || details.type || '').toString().trim(),
        latitude: details.latitude || '',
        longitude: details.longitude || '',
        stateId: details.state?.id || details.stateId || '',
        districtId: details.district?.id || details.districtId || '',
        taluka: details.taluka || '',
        branchId: details.branch?.id || details.branchId || '',
      });

      if (details.state?.id) fetchCities(details.state.id);
      setFormError('');
      setIsModalOpen(true);
    } catch (err) {
      console.error('Error fetching warehouse details:', err);
      // Fallback to existing data if fetch fails, or show error
      // using the existing wh object as fallback
      setForm({
        id: wh.id,
        warehouse_name: wh.warehouse_name || '',
        contact_name: wh.contact_name || '',
        contact_email: wh.contact_email || '',
        contact_mobile_no: wh.contact_mobile_no || '',
        address: wh.address || '',
        type: (wh.service_provider || wh.type || '').toString().trim(),
        latitude: wh.latitude || '',
        longitude: wh.longitude || '',
        stateId: wh.state?.id || '',
        districtId: wh.district?.id || '',
        taluka: wh.taluka || '',
        branchId: wh.branch?.id || '',
      });
      if (wh.state?.id) fetchCities(wh.state.id);
      setFormError('Failed to fetch latest details. Showing cached data.');
      setIsModalOpen(true);
    }
  };

  // Add new warehouse
  const handleAdd = () => {
    setForm({
      id: null,
      warehouse_name: '',
      contact_name: '',
      contact_email: '',
      contact_mobile_no: '',
      address: '',
      type: 'OPEN',
      latitude: '',
      longitude: '',
      stateId: '',
      districtId: '',
      taluka: '',
      branchId: '',
    });
    setFormError('');
    setIsModalOpen(true);
  };

  // Download sample Excel

  const handleDownloadSample = async () => {
    try {
      const res = await axios.get('download/warehouse-upload-sample', {
        responseType: 'blob', // 👈 Important: tells axios to treat response as binary data
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'warehouse-sample.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove(); // cleanup
    } catch (err) {
      console.error('Download error:', err);
      alert('Failed to download sample file');
    }
  };

  const handleUploadExcel = async () => {
    setUploadError('');
    if (!file) return setUploadError('Please select a file first');
    if (!form.branchId) return setUploadError('Please select a branch before uploading');

    const formDataObj = new FormData();
    formDataObj.append('file', file);
    formDataObj.append('branch_id', form.branchId);

    try {
      await axios.post('warehouse/excel/upload', formDataObj, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert('✅ Excel uploaded successfully!');
      setIsUploadModalOpen(false);
      setFile(null);
      setForm({ ...form, branchId: '' });
      fetchWarehouses(page, limit, search, stateFilter, cityFilter, branchFilter);
    } catch (err) {
      console.error('Upload error:', err.response?.data || err.message);

      const respData = err.response?.data;
      if (respData) {
        const msg = respData.message;
        let errorMsg = '';
        let errorsArray = [];

        // Distinguish between pure string messages and structured object messages
        if (typeof msg === 'object') {
          errorMsg = `❌ Upload failed:\n\n${msg.message || 'Validation Error'}`;
          errorsArray = Array.isArray(msg.errors) ? msg.errors : [];
        } else if (typeof msg === 'string') {
          errorMsg = `❌ Upload failed:\n\n${msg}`;
          errorsArray = Array.isArray(respData.errors) ? respData.errors : [];
        } else {
          errorMsg = `❌ Upload failed. Please try again.`;
        }

        // Only format array if the bulk upload errors format exists
        if (errorsArray.length > 0) {
          errorMsg += '\n\nDetails:\n' + errorsArray.map(e => `• ${e}`).join('\n');
        }
        
        setUploadError(errorMsg);
        // Refresh table in case partial records were saved before validation failed
        fetchWarehouses();
      } else {
        setUploadError('❌ Failed to upload Excel file. Please try again.');
      }
    }
  };

  const handleExport = async () => {
    try {
      // Build URL with filters
      const queryParams = new URLSearchParams();

      if (stateFilter) queryParams.append('state_id', stateFilter);
      if (cityFilter) queryParams.append('district_id', cityFilter);
      if (branchFilter) queryParams.append('branch_id', branchFilter);
      if (search) queryParams.append('name', search);

      const queryString = queryParams.toString();
      const url = `warehouse/excel/download${queryString ? `?${queryString}` : ''}`;

      const res = await axios.get(url, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });

      // Create downloadable Excel blob
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', 'warehouses.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Export error:', err.response?.data || err.message);
      alert('❌ Failed to export warehouse data');
    }
  };

  // Ref to track if initial data has been fetched
  const initialDataFetchedRef = useRef(false);

  // Ref to prevent duplicate API calls when filters change
  const fetchDataRef = useRef(null);

  // Fetch initial data only once
  useEffect(() => {
    if (!initialDataFetchedRef.current) {
      const user = JSON.parse(localStorage.getItem('user'));
      const userRole = user?.roles?.[0]?.name || '';
      setRole(userRole);

      fetchStates();
      fetchBranches();
      initialDataFetchedRef.current = true;
    }
  }, []);

  // Fetch warehouses when filters or pagination changes
  useEffect(() => {
    // Clear any existing timeout to prevent duplicate calls
    if (fetchDataRef.current) {
      clearTimeout(fetchDataRef.current);
    }

    // Set a timeout to debounce the API call
    fetchDataRef.current = setTimeout(() => {
      fetchWarehouses(page, limit, search, stateFilter, cityFilter, branchFilter);
    }, 300);

    // Cleanup function to clear the timeout if component unmounts or dependencies change
    return () => {
      if (fetchDataRef.current) {
        clearTimeout(fetchDataRef.current);
      }
    };
  }, [page, limit, search, stateFilter, cityFilter, branchFilter]);

  const totalPages = Math.ceil(total / limit);

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-blue-100 p-10  text-gray-900">
      {/* Header */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 md:mb-10 gap-4">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 tracking-tight">
          🏢 Warehouses
        </h2>



        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 w-full sm:w-auto">
          {role !== 'User' && (
            <>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  setUploadError('');
                  setIsUploadModalOpen(true);
                }}
                className="flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-700 transition text-white px-4 py-2.5 text-sm sm:text-base rounded-lg shadow-md w-full"
              >
                <Upload size={16} className="flex-shrink-0" />
                <span className="truncate">Upload Excel</span>
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleAdd}
                className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2.5 text-sm sm:text-base rounded-lg shadow-md w-full"
              >
                <Plus size={16} className="flex-shrink-0" />
                <span className="truncate">Add Warehouse</span>
              </motion.button>
            </>
          )}

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleExport}
            className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 transition text-white px-4 py-2.5 text-sm sm:text-base rounded-lg shadow-md w-full"
          >
            <Download size={16} className="flex-shrink-0" />
            <span className="truncate">Export Excel</span>
          </motion.button>
        </div>

      </div>




      {/* Filters */}

      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4 mb-6 w-full">
        {/* Search Input */}
        <input
          type="text"
          placeholder="🔍 Search warehouses..."
          className="w-full sm:flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm sm:text-base shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* State Filter */}
        <select
          className="w-full sm:flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm sm:text-base shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          value={stateFilter}
          onChange={(e) => {
            const selectedState = e.target.value;
            setStateFilter(selectedState);
            setCityFilter('');
            setBranchFilter('');
            fetchCities(selectedState);
          }}
        >
          <option value="">Filter by State</option>
          {states.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>

        {/* City Filter */}
        <select
          className="w-full sm:flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm sm:text-base shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:opacity-60"
          value={cityFilter}
          onChange={(e) => setCityFilter(e.target.value)}
          disabled={!stateFilter}
        >
          <option value="">Filter by City</option>
          {cities.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>

        {/* Branch Filter */}
        {role !== 'Branch' && (
          <select
            className="w-full sm:flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm sm:text-base shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            value={branchFilter}
            onChange={(e) => setBranchFilter(e.target.value)}
          >
            <option value="">Filter by Branch</option>
            {branches
              .filter((b) =>
                !stateFilter ||
                (b.state && String(b.state.id) === String(stateFilter)) ||
                (b.state_id && String(b.state_id) === String(stateFilter))
              )
              .map((b) => (
                <option key={b.id} value={b.id}>
                  {b.first_name} {b.last_name || ''}
                </option>
              ))}
          </select>
        )}
      </div>


      {/* Table Error */}
      {tableError && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 text-lg p-4 rounded mb-6 shadow">
          {tableError}
        </div>
      )}



      {/* Table */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="overflow-hidden rounded-2xl shadow-xl border border-gray-100 bg-white"
      >
        <div className="overflow-x-auto max-h-[80vh] relative">
          <table className="w-full text-left border-collapse min-w-[1000px]">
            <thead className="bg-gray-100 border-b border-gray-200">
              <tr>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider min-w-[220px] w-[25%]">Warehouse</th>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider w-[12%]">State</th>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider w-[12%]">City</th>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider w-[12%]">Branch</th>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider w-[12%]">Taluka</th>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider w-[20%]">Address</th>
                {role !== 'User' && (
                  <th className="py-4 px-6 text-center text-sm font-semibold text-gray-600 uppercase tracking-wider w-[7%]">Actions</th>
                )}
              </tr>
            </thead>

            <tbody>
              {warehouses.map((wh) => (
                <motion.tr
                  key={wh.id}
                  className="hover:bg-gray-50 transition-colors duration-200 text-gray-700"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                >
                  {/* Warehouse Name */}
                  <td className="py-4 px-6 text-sm max-w-[260px] md:max-w-[300px]">
                    <div className="flex flex-col">
                      <span className="font-semibold truncate">{wh.warehouse_name}</span>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="text-xs text-gray-500">{wh.warehouse_code}</span>
                        {wh.warehouse_code && (
                          <>
                            <button
                              onClick={() => handleCopyCode(wh.warehouse_code, wh.id)}
                              className="text-blue-600 hover:text-blue-800 transition"
                              title="Copy warehouse code"
                            >
                              <Copy size={12} />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </td>

                  {/* Other Columns */}
                  <td className="py-4 px-6 text-sm">{wh.state?.name}</td>
                  <td className="py-4 px-6 text-sm">{wh.district?.name}</td>
                  <td className="py-4 px-6 text-sm">{wh.branch?.first_name || "-"}</td>
                  <td className="py-4 px-6 text-sm">{wh.taluka}</td>

                  {/* Address + Copy Icon */}
                  <td
                    className="py-4 px-6 text-sm flex items-center gap-2 max-w-[200px]"
                    title={wh.address || "No address"}
                  >
                    <span className="truncate">
                      {wh.address
                        ? wh.address.length > 10
                          ? wh.address.substring(0, 10) + "..."
                          : wh.address
                        : "—"}
                    </span>

                    <button
                      onClick={() => handleCopy(wh.address, wh.id)}
                      className="text-blue-600 hover:text-blue-800 transition"
                      title="Copy full address"
                    >
                      <Copy size={14} />
                    </button>

                    {copiedId === wh.id && (
                      <span className="text-xs text-green-600">Copied!</span>
                    )}
                  </td>

                  {/* Actions */}
                  {role !== 'User' && (
                    <td className="py-4 px-6 text-center text-sm">
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => handleEdit(wh)}
                        className="flex items-center justify-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1.5 rounded-md text-[11px] sm:text-xs md:text-sm mx-auto"
                      >
                        <Edit2 size={13} /> Edit
                      </motion.button>
                    </td>
                  )}
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>


      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6 sm:mt-8 text-base sm:text-lg">
        <button
          disabled={page === 1}
          onClick={() => page > 1 && setPage(page - 1)}
          className="w-full sm:w-auto px-4 sm:px-5 py-2 bg-blue-200 hover:bg-blue-300 disabled:opacity-40 rounded-lg font-medium order-2 sm:order-1"
        >
          ⬅ Previous
        </button>
        <span className="text-gray-700 font-semibold order-1 sm:order-2">
          Page {page} of {totalPages || 1}
        </span>
        <button
          disabled={page === totalPages || totalPages === 0}
          onClick={() => page < totalPages && setPage(page + 1)}
          className="w-full sm:w-auto px-4 sm:px-5 py-2 bg-blue-200 hover:bg-blue-300 disabled:opacity-40 rounded-lg font-medium order-3"
        >
          Next ➡
        </button>
      </div>

      {/* Add/Edit Modal */}
      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-2xl p-5 md:p-10 w-[95%] md:w-[600px] max-h-[90vh] overflow-y-auto shadow-2xl relative"
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
            >
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
              >
                <X size={26} />
              </button>
              <h3 className="text-2xl md:text-3xl font-bold mb-5">
                {form.id ? '✏️ Edit Warehouse' : '➕ Add Warehouse'}
              </h3>
              {formError && (
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 text-lg p-4 rounded mb-6 shadow">
                  {formError}
                </div>
              )}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <input
                  name="warehouse_name"
                  placeholder="Warehouse Name"
                  className="border p-3 rounded-lg"
                  value={form.warehouse_name}
                  onChange={handleChange}
                />
                <input
                  name="contact_name"
                  placeholder="Contact Name"
                  className="border p-3 rounded-lg"
                  value={form.contact_name}
                  onChange={handleChange}
                />
                <input
                  name="contact_email"
                  placeholder="Contact Email"
                  className="border p-3 rounded-lg"
                  value={form.contact_email}
                  onChange={handleChange}
                />
                <input
                  name="contact_mobile_no"
                  placeholder="Mobile No"
                  className="border p-3 rounded-lg"
                  value={form.contact_mobile_no}
                  onChange={handleChange}
                />
                <input
                  name="address"
                  placeholder="Address"
                  className="border p-3 rounded-lg col-span-1 md:col-span-2"
                  value={form.address}
                  onChange={handleChange}
                />
                <input
                  name="type"
                  placeholder="Stoarge Type"
                  className="border p-3 rounded-lg"
                  value={form.type}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="latitude"
                  placeholder="Latitude"
                  className="border p-3 rounded-lg"
                  value={form.latitude}
                  onChange={handleChange}
                />
                <input
                  type="number"
                  name="longitude"
                  placeholder="Longitude"
                  className="border p-3 rounded-lg"
                  value={form.longitude}
                  onChange={handleChange}
                />
                <select
                  name="stateId"
                  value={form.stateId}
                  onChange={handleChange}
                  className="border p-3 rounded-lg"
                >
                  <option value="">Select State</option>
                  {states.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>
                  ))}
                </select>
                <select
                  name="branchId"
                  value={form.branchId || ''}
                  onChange={(e) =>
                    setForm({ ...form, branchId: e.target.value })
                  }
                  className="border p-3 rounded-lg w-full"
                  disabled={!form.stateId}
                >
                  <option value="">Select Branch</option>
                  {branches
                    .filter((b) =>
                      !form.stateId ||
                      (b.state && String(b.state.id) === String(form.stateId)) ||
                      (b.state_id && String(b.state_id) === String(form.stateId))
                    )
                    .map((b) => (
                      <option key={b.id} value={b.id}>
                        {b.first_name}
                      </option>
                    ))}
                </select>
                <select
                  name="districtId"
                  value={form.districtId}
                  onChange={handleChange}
                  className="border p-3 rounded-lg"
                >
                  <option value="">Select City</option>
                  {cities.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </select>
                <input
                  name="taluka"
                  placeholder="Taluka"
                  className="border p-3 rounded-lg"
                  value={form.taluka}
                  onChange={handleChange}
                />
              </div>
              <div className="mt-6 md:mt-8 flex justify-end space-x-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded-lg"
                >
                  Cancel
                </button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleSave}
                  disabled={loading}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg font-semibold"
                >
                  {loading ? 'Saving...' : form.id ? 'Update' : 'Save'}
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Upload Modal */}
      <AnimatePresence>
        {isUploadModalOpen && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-2xl p-5 md:p-8 w-full max-w-[90%] md:max-w-[500px] shadow-2xl"
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
            >
              <h3 className="text-xl md:text-2xl font-bold mb-4">
                📤 Upload Excel File
              </h3>
              {uploadError && (
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 text-sm p-3 rounded mb-4 whitespace-pre-line shadow max-h-40 overflow-y-auto">
                  {uploadError}
                </div>
              )}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleDownloadSample}
                className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-xl"
              >
                <Download size={15} /> Download Sample
              </motion.button>

              <select
                name="branchId"
                value={form.branchId || ''}
                onChange={(e) => setForm({ ...form, branchId: e.target.value })}
                className="border p-3 mt-2  rounded-lg w-full mb-4"
              >
                <option value="">Select Branch</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.first_name}
                  </option>
                ))}
              </select>

              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={(e) => setFile(e.target.files[0])}
                className="mb-4 block w-full border p-2 rounded-lg"
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setIsUploadModalOpen(false)}
                  className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded-lg"
                >
                  Cancel
                </button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleUploadExcel}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg font-semibold"
                >
                  Submit
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
